import React from 'react';

import gloock from '@/public/images/theme_features/fonts.svg';

import NextImage from '../UI/nextImage/NextImage';
import { Title } from '../UI/title/Title';

import styles from './FontsBlock.module.scss';

const FontsBlock = () => {
    return (
        <div className={styles.fonts}>
            <div className={styles.fonts__info}>
                <Title text="Multiple Font Pairings" size="xs" className={styles.heading} />
                <p className={styles.excerpt}>
                    Select from multiple font pairings to ensure readability and character in your
                    typography.
                </p>
            </div>
            <div className={styles.fonts__block}>
                <NextImage
                    src={gloock.src}
                    alt="Gloock Title"
                    fill
                    loading="lazy"
                    sizes="
                            (max-width: 480px) 75vw,
                            (max-width: 768px) 338px,
                            (max-width: 1024px) 36vw, 
                            (max-width: 1150px) 26.2vw,
                            (max-width: 1300px) 24vw, 
                                                338px"
                />
            </div>
        </div>
    );
};

export default FontsBlock;
